import { Directive } from '@angular/core';

@Directive({
    selector: '[ui-select-label]'
})
export class UISelectLabelDirective {}
